export default {
    table: [
        {
            id: 0,
            name: 'Abdul Karim',
            email: 'karim@wxample.com',
            picture: require('../../../assets/people/a5.jpg'),
            phone: '01712344321',
            permissions:[
                {
                    name: 'Prescription',
                    status: true
                },
                {
                    name: 'Doctor',
                    status: true
                },
                {
                    name: 'User',
                    status: false
                },
                {
                    name: 'Transaction',
                    status: true
                },
                {
                    name: 'Report',
                    status: false
                }
            ]
        },
        {
            id: 1,
            name: 'Rahim Hasan',
            email: 'rahimhasan@wxample.com',
            picture: require('../../../assets/people/a4.jpg'),
            phone: '01823455432',
            permissions:[
                {
                    name: 'Prescription',
                    status: true
                },
                {
                    name: 'Doctor',
                    status: false
                },
                {
                    name: 'User',
                    status: false
                },
                {
                    name: 'Transaction',
                    status: true
                },
                {
                    name: 'Report',
                    status: false
                }
            ]
        },
        {
            id: 2,
            name: 'Karim Hossain',
            email: 'karimhossain@wxample.com',
            picture: require('../../../assets/people/a2.jpg'),
            phone: '01934566543',
            permissions:[
                {
                    name: 'Prescription',
                    status: true
                },
                {
                    name: 'Doctor',
                    status: true
                },
                {
                    name: 'User',
                    status: true
                },
                {
                    name: 'Transaction',
                    status: true
                },
                {
                    name: 'Report',
                    status: false
                }
            ]
        },
        {
            id: 3,
            name: 'Abdur Rahman',
            email: 'abdurrahmon@wxample.com',
            picture: require('../../../assets/people/a3.jpg'),
            phone: '01545677654',
            permissions:[
                {
                    name: 'Prescription',
                    status: false
                },
                {
                    name: 'Doctor',
                    status: false
                },
                {
                    name: 'User',
                    status: false
                },
                {
                    name: 'Transaction',
                    status: true
                },
                {
                    name: 'Report',
                    status: true
                }
            ]
        },
        {
            id: 4,
            name: 'Farhan Ahmed',
            email: 'farhanahmed@wxample.com',
            picture: require('../../../assets/people/a1.jpg'),
            phone: '01345688765',
            permissions:[
                {
                    name: 'Prescription',
                    status: true
                },
                {
                    name: 'Doctor',
                    status: true
                },
                {
                    name: 'User',
                    status: false
                },
                {
                    name: 'Transaction',
                    status: true
                },
                {
                    name: 'Report',
                    status: true
                }
            ]
        },
    ],
};
